import qs from 'qs';
import { useLocation } from 'react-router-dom';

export function useQuery() {
  return qs.parse(useLocation().search, { ignoreQueryPrefix: true });
}
